export const getInitialGroupMemberCounts = (groupCount: number, remainingMemberCapacity = Infinity): number[] => {
  if (remainingMemberCapacity < groupCount) {
    return [];
  }
  const extraMembersAvailable = Math.floor(Math.max(0, remainingMemberCapacity - groupCount));
  return Array.from({ length: groupCount }, (_, index) => 1 + Number(index < extraMembersAvailable));
};
